import { motion } from "framer-motion";
import React from "react";
import { socialData } from "../data/socialData";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import ContactUs from "../component/HomePage/ContactUs";

export default function ContactPage() {
  return (
    <div className="w-full flex flex-col lg:flex-row  mx-auto bg-[#0F172A] text-white  shadow-xl border border-gray-800 overflow-hidden">
      {/* Left Section - Contact Info */}
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full lg:w-1/2 p-8 flex flex-col justify-center"
      >
        <h3 className="text-3xl font-extrabold text-[#C9A227] text-center lg:text-left mb-6">
          Get in Touch
        </h3>

        {/* Business Information */}
        <div className="space-y-3 text-gray-300">
          <p className="text-lg font-semibold">{socialData.name}</p>
          {/* <p className="text-sm text-gray-400">
            We are committed to providing the best services and customer support.
            Feel free to reach out to us for any inquiries.
          </p> */}
        </div>

        {/* Address */}
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            socialData.address
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 mt-4 text-gray-300 hover:text-[#C9A227] transition"
        >
          <FaMapMarkerAlt size={24} className="text-[#C9A227]" />
          <span className="text-lg">{socialData.address}</span>
        </a>

        {/* Phone Numbers */}
        {[socialData.contact1, socialData.contact2].map((contact, index) => (
          <a
            key={index}
            href={`tel:${contact}`}
            className="flex items-center gap-3 text-gray-300 hover:text-[#C9A227] transition mt-2"
          >
            <FaPhone size={22} className="text-[#C9A227]" />
            <span className="text-lg">{contact}</span>
          </a>
        ))}

        {/* Email */}
        <a
          href={`mailto:${socialData.mail}`}
          className="flex items-center gap-3 text-gray-300 hover:text-[#C9A227] transition mt-2"
        >
          <FaEnvelope size={22} className="text-[#C9A227]" />
          <span className="text-lg">{socialData.mail}</span>
        </a>

        {/* Working Hours */}
        {/* <div className="mt-6">
          <p className="text-lg font-semibold text-[#C9A227]">Working Hours</p>
          <p className="text-gray-400 text-sm mt-1">Mon - Fri: 9 AM - 6 PM</p>
          <p className="text-gray-400 text-sm">Sat - Sun: Closed</p>
        </div> */}

        {/* Social Media Links */}
        <div className="mt-8 flex items-center space-x-4">
          {[FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram].map(
            (Icon, index) => (
              <motion.a
                key={index}
                href="#"
                className="p-3 rounded-full bg-gray-800 hover:bg-[#C9A227] text-white transition duration-300"
                whileHover={{ scale: 1.1 }}
              >
                <Icon size={20} />
              </motion.a>
            )
          )}
        </div>
      </motion.div>

      {/* Right Section - Contact Form */}
      <motion.div
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full lg:w-1/2 mt-[8%] bg-white p-8 flex flex-col justify-center"
      >
        
        <ContactUs />
      </motion.div>
    </div>
  );
}
